/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CreationKeyWords.vue?vue&type=template&id=06b3f2ce&"
import script from "./CreationKeyWords.vue?vue&type=script&lang=js&"
export * from "./CreationKeyWords.vue?vue&type=script&lang=js&"
import style0 from "./CreationKeyWords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports